var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJointCare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69.459,
    height: 110.76,
    viewBox: "0 0 69.459 110.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    transform: "translate(-12.539 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_944",
    "data-name": "Group 944",
    transform: "translate(12.539 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1198",
    "data-name": "Path 1198",
    d: "M61.985,47.051a13.99,13.99,0,0,0,1.431-4.071A14.312,14.312,0,0,0,60.09,30.853,22.776,22.776,0,0,1,57.752,27.7a7.08,7.08,0,0,0,2.337-5.259,7.16,7.16,0,0,0-5.359-6.921V2.786A1.786,1.786,0,0,0,52.942,1H31.505a1.786,1.786,0,0,0-1.786,1.786v14.59a20.493,20.493,0,0,1-5.284,13.393,1.129,1.129,0,0,0-.079.082,14.275,14.275,0,0,0-1.878,16.183,14.267,14.267,0,0,0,.005,18.677A14.249,14.249,0,0,0,23.711,81.1a7.047,7.047,0,0,0-1.138,3.859A7.153,7.153,0,0,0,29.406,92.1a18.036,18.036,0,0,1,.313,3.282v14.59a1.786,1.786,0,0,0,1.786,1.786H52.942a1.786,1.786,0,0,0,1.786-1.786V95.383a20.5,20.5,0,0,1,5.358-13.475A14.307,14.307,0,0,0,63.415,69.78a13.887,13.887,0,0,0-1.431-4.071,14.3,14.3,0,0,0,0-18.658ZM26.966,33.3c.025-.025.048-.052.073-.077a24.079,24.079,0,0,0,6.253-15.842V4.573H51.156V17.078a1.786,1.786,0,0,0,1.786,1.786,3.557,3.557,0,0,1,1.635,6.724A1.786,1.786,0,0,0,53.818,28a26.11,26.11,0,0,0,3.593,5.222,10.762,10.762,0,0,1,2.492,9.12A10.641,10.641,0,0,1,51.574,50.8a10.8,10.8,0,0,1-6.228-.566A14.237,14.237,0,0,0,49.37,40.3H45.8a10.719,10.719,0,1,1-18.831-7ZM22.573,56.38a10.593,10.593,0,0,1,2.079-6.335,14.242,14.242,0,0,0,17.573,2.63,14.319,14.319,0,0,0,10.045,1.631,14.115,14.115,0,0,0,7.537-4.243,10.689,10.689,0,0,1,0,12.636,14.1,14.1,0,0,0-7.537-4.243,14.319,14.319,0,0,0-10.045,1.631,14.237,14.237,0,0,0-17.57,2.624,10.625,10.625,0,0,1-2.083-6.331ZM57.409,79.541a24.079,24.079,0,0,0-6.253,15.842v12.8H33.292v-12.8a22.377,22.377,0,0,0-.749-5.624,1.8,1.8,0,0,0-2.113-1.292,3.775,3.775,0,0,1-.711.068,3.563,3.563,0,0,1-2.451-6.158,1.784,1.784,0,0,0,.064-2.528A10.714,10.714,0,1,1,45.8,72.458H49.37a14.246,14.246,0,0,0-4.025-9.933,10.83,10.83,0,0,1,6.228-.566A10.645,10.645,0,0,1,59.9,70.421,10.756,10.756,0,0,1,57.409,79.541Z",
    transform: "translate(-7.458 -1)",
    fill: "#003863"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1199",
    "data-name": "Path 1199",
    d: "M31.932,31.932V28.359A5.366,5.366,0,0,1,26.573,23H23A8.942,8.942,0,0,0,31.932,31.932Z",
    transform: "translate(-4.312 16.302)",
    fill: "#003863"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1200",
    "data-name": "Path 1200",
    d: "M23,44.932h3.573a5.366,5.366,0,0,1,5.359-5.359V36A8.942,8.942,0,0,0,23,44.932Z",
    transform: "translate(-4.312 26.526)",
    fill: "#003863"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1201",
    "data-name": "Path 1201",
    d: "M0,0H3.573V7.58H0Z",
    transform: "translate(3.127 35.206) rotate(-45)",
    fill: "#003863"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1202",
    "data-name": "Path 1202",
    d: "M0,0H7.58V3.573H0Z",
    transform: "translate(3.123 75.548) rotate(-45)",
    fill: "#003863"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1203",
    "data-name": "Path 1203",
    d: "M0,0H3.573V7.989H0Z",
    transform: "translate(0 48.046) rotate(-63.435)",
    fill: "#003863"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1204",
    "data-name": "Path 1204",
    d: "M0,0H7.989V3.573H0Z",
    transform: "translate(0.002 62.693) rotate(-26.565)",
    fill: "#003863"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1205",
    "data-name": "Path 1205",
    d: "M0,0H7.58V3.573H0Z",
    transform: "translate(58.502 38.043) rotate(-45)",
    fill: "#003863"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1206",
    "data-name": "Path 1206",
    d: "M0,0H3.573V7.58H0Z",
    transform: "translate(58.496 72.723) rotate(-45)",
    fill: "#003863"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1207",
    "data-name": "Path 1207",
    d: "M0,0H7.989V3.573H0Z",
    transform: "translate(60.718 48.421) rotate(-26.565)",
    fill: "#003863"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1208",
    "data-name": "Path 1208",
    d: "M0,0H3.573V7.989H0Z",
    transform: "translate(60.72 62.36) rotate(-63.435)",
    fill: "#003863"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJointCare);
export default __webpack_public_path__ + "static/media/jointCare.4590a156.svg";
export { ForwardRef as ReactComponent };